// Strings the backend and the socket server agree on. Values are sent or
// compared as-is; never change one without the backend.

export const ACTION_TYPES = Object.freeze({
  ACTION: 'ACTION',
  AUTH: 'AUTH',
  SETTING: 'SETTING',
  HEAT_CONFIGURATION: 'HEAT_CONFIGURATION',
  MASTER_CONTROL: 'MASTER_CONTROL',
  LOCAL_MASTER_CONTROL: 'LOCAL_MASTER_CONTROL',
  GLOBAL_MASTER_CONTROL: 'GLOBAL_MASTER_CONTROL',
  FAST_MASTER_CONTROL: 'FAST_MASTER_CONTROL',
  AUDIT_TRAIL: 'AUDIT_TRAIL',
  GLOBAL_TELEMETRY_OVERVIEW: 'GLOBAL_TELEMETRY_OVERVIEW',
  GLOBAL_DATA_TELEMETRY_OVERVIEW: 'GLOBAL_DATA_TELEMETRY_OVERVIEW',
  SSR_RESET: 'SSR_RESET',
  THERMOCOUPLE_RESET: 'THERMOCOUPLE_RESET',
  GROUND_RESET: 'GROUND_RESET',
  HPLP_RESET: 'HPLP_RESET',
  TIMEOUT_RESET: 'TIMEOUT_RESET',
  BMS_RESET: 'BMS_RESET',
  LOAD_EXCEED_RESET: 'LOAD_EXCEED_RESET',
});

// Sent as `fault_reset_type`; the audit trail records the reset under the same name.
export const FAULT_RESET_TYPES = Object.freeze({
  GROUND: ACTION_TYPES.GROUND_RESET,
  BMS: ACTION_TYPES.BMS_RESET,
  HPLP: ACTION_TYPES.HPLP_RESET,
  TIMEOUT: ACTION_TYPES.TIMEOUT_RESET,
});

export const DEVICE_TYPES = Object.freeze({
  ESS: 'ESS',
  TGS: 'TGS',
  TES: 'TES',
});

// The names the fault lists (electricalFaultsList, gasFaultsList, getFaultsList) give each fault row.
export const FAULT_TYPES = Object.freeze({
  SSR: 'ssr fault',
  SSR_OVER_CURRENT: 'ssr over current',
  THERMOCOUPLE: 'thermocouple fault',
  GROUND: 'ground fault',
  BMS: 'bms fault',
  HPLP: 'hp/lp fault',
  TIMEOUT: 'timeout fault',
});

// `fault_type` for POST and GET /attends. 'srr_over_current' is what the UI has
// always sent; confirm with the backend before correcting the spelling.
export const FAULT_ATTEND_KEYS = Object.freeze({
  [FAULT_TYPES.SSR]: 'ssr_fault',
  [FAULT_TYPES.SSR_OVER_CURRENT]: 'srr_over_current',
  [FAULT_TYPES.THERMOCOUPLE]: 'thermocouple_fault',
  [FAULT_TYPES.GROUND]: 'ground_fault',
  [FAULT_TYPES.BMS]: 'bms_fault',
  [FAULT_TYPES.HPLP]: 'hplp_fault',
  [FAULT_TYPES.TIMEOUT]: 'timeout_fault',
});

// `graph_type` for GET /live-graph, and the socket event that pushes each graph.
export const GRAPH_TYPES = Object.freeze({
  HEATER: 'heater_graph',
  ENCLOSURE: 'enclosure_graph',
  GAS_ENCLOSURE: 'gas_enclosure_graph',
  OUTSIDE: 'outside_graph',
  GAS: 'gas_graph',
  SNOW: 'snow_graph',
  WIND: 'wind_graph',
  GAS_SNOW: 'gas_snow_graph',
  GAS_WIND: 'gas_wind_graph',
});

// Server → client socket events other than the graphs above.
export const SOCKET_EVENTS = Object.freeze({
  SWITCH_AUDIT: 'switchAudit',
  BLOWER_AUDIT: 'blowerAudit',
  SSR_UPDATE: 'ssrUpdate',
  SCHEDULE_LIST: 'scheduleList',
  THERMOCOUPLE_UPDATE: 'thermocoupleUpdate',
});
